import { httpApi } from '@app/api/http.api';

// eslint-disable-next-line
export const getDashboardMetaData = (firmId: number): Promise<any> =>
  // eslint-disable-next-line
  httpApi.get<any[]>('/apim/v1/dashboard/firm/' + firmId).then(({ data }) => data);
